/**
 * Limites dos avisos didáticos, num arquivo de dados.
 *
 * O instrutor ajusta aqui sem mexer na lógica. Os valores abaixo são um ponto
 * de partida didático, ainda NÃO confirmado pelo instrutor (pergunta em aberto
 * do plano), e não valem como limite de capacidade de equipamento.
 */
export interface ConfiguracaoAvisos {
  /**
   * Abertura máxima entre duas pernas de uma ancoragem em V, W ou M, em graus.
   * Com 90° cada perna do V recebe cerca de 71% da carga; com 120°, 100%; e a
   * partir daí a perna recebe mais do que a própria carga.
   */
  readonly anguloMaximoAncoragemGraus: number
}

export const CONFIGURACAO_AVISOS_PADRAO: ConfiguracaoAvisos = {
  anguloMaximoAncoragemGraus: 90,
}

/** Carga inicial de uma ancoragem nova, em kgf: uma maca com vítima e um socorrista. */
export const CARGA_PADRAO_ANCORAGEM_KGF = 200
export const CARGA_MINIMA_ANCORAGEM_KGF = 10
export const CARGA_MAXIMA_ANCORAGEM_KGF = 1000
/** Quanto a direção da carga pode sair da vertical no estudo da equalização, em graus. */
export const DESVIO_MAXIMO_CARGA_GRAUS = 60
